// extracted by mini-css-extract-plugin
export default {"busy-timeslots-form":"AddBusySlots_busy-timeslots-form__btnzA","c-field-label":"AddBusySlots_c-field-label__lbKfS"};